<template>
    <div class="per-container">
        <div class="flexbox-container">
            <div class="flexbox-box">
                <div class="flexbox-box-bd">
                    <p style="color: #5182E4;line-height: 70px;font-size: 22px;text-align: center;">登录</p>
                    <el-form ref="form" label-width="60px" :model="model" :rules="rules">
                        <el-form-item label="账号" prop="name">
                            <el-input v-model="model.name" placeholder="请输入账号" @keyup.enter.native="login"></el-input>
                        </el-form-item>
                        <el-form-item label="密码" prop="pwd">
                            <el-input v-model="model.pwd" type="password" placeholder="请输入密码" @keyup.enter.native="login"></el-input>
                        </el-form-item>
                        <el-form-item prop="rememberMe">
                            <el-checkbox v-model="model.rememberMe">记住密码</el-checkbox>
                        </el-form-item>
                    </el-form>
                    <p style="line-height: 70px;text-align: center;"><button @click="login" class="dengl">登录</button></p>
                </div>
                <div class="form-banner">
                    <div class="form-banner-img"></div>
                </div>
            </div>
        </div>
        <form ref="submitForm" method="post" :action="loginUrl">
            <input name="redirect" type="hidden" :value="redirectUrl"/>
            <input name="failureUrl" type="hidden" :value="failureUrl"/>
            <input v-model="model.name" type="hidden" name="username">
            <input v-model="model.pwd" type="hidden" name="password">
            <input v-if="model.rememberMe" value="true" type="hidden" name="remember-me">
        </form>
    </div>
</template>

<script>
    import config from '../config'

    export default {
        name: "Login",
        data(){
            const defaultRedirectUrl = document.location.origin + document.location.pathname + '#/main'
            const failureUrl = document.location.origin + document.location.pathname + '#/login'
            return {
                model: {
                    name: '',
                    pwd: '',
                    rememberMe: false
                },
                rules: {
                    name: [
                        {required: true, message: '请输入用户名', trigger: 'blur'}
                    ],
                    pwd: [
                        {required: true, message: '请输入密码', trigger: 'blur'}
                    ]
                },
                loginUrl: config.backendUrl+'/login',
                redirectUrl: this.$route.query.redirect || defaultRedirectUrl,
                failureUrl: failureUrl
            }
        },
        created(){
          if(this.$route.query.error){
              this.$nextTick(()=>{
                  this.$message({
                      type: 'error',
                      message: '用户名或密码错误!'
                  })
              })
          }
        },
        methods:{
            login() {
                this.$refs.form.validate(valid => {
                    if(!valid){
                        return
                    }
                    this.$refs.submitForm.submit()
                })
            }
        }
    }
</script>

<style scoped>

</style>
